module.exports = __webpack_public_path__ + "static/media/trivvy-question-bank.38cbe8cd.png";